// Upsell functionality for Shopify
// This file should be loaded AFTER Alpine.js

document.addEventListener('alpine:init', () => {
    // Main upsell component
    Alpine.data('upsellComponent', () => ({
        showSidePane: false,
        
        init() {
            // Watch for changes to showSidePane and handle body scroll
            this.$watch('showSidePane', (value) => {
                if (value) {
                    // Store original overflow value
                    this.originalOverflow = document.body.style.overflow;
                    document.body.style.overflow = 'hidden';
                } else {
                    // Restore original overflow or remove the style
                    document.body.style.overflow = this.originalOverflow || '';
                }
            });
        },
        
        toggleSidePane() {
            this.showSidePane = !this.showSidePane;
        },
        
        closeSidePane() {
            this.showSidePane = false;
        },
        
        async addToCartAlpine(variantId, event) {
            event.preventDefault();
            
            const button = event.target;
            const originalText = button.textContent;
            
            try {
                // Disable button and show loading state
                button.disabled = true;
                button.textContent = 'Adding...';
                
                const formData = {
                    'items': [{
                        'id': variantId,
                        'quantity': 1
                    }]
                };
                
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData)
                });
                
                if (response.ok) {
                    // Success - update cart count, show success message, etc.
                    button.textContent = 'Added!';
                    
                    // Update cart count if you have a cart counter
                    this.updateCartCount();
                    
                    // Reset button after delay
                    setTimeout(() => {
                        button.textContent = originalText;
                        button.disabled = false;
                    }, 2000);
                    
                } else {
                    throw new Error('Failed to add to cart');
                }
                
            } catch (error) {
                console.error('Error adding to cart:', error);
                button.textContent = 'Error';
                
                // Reset button after delay
                setTimeout(() => {
                    button.textContent = originalText;
                    button.disabled = false;
                }, 2000);
            }
        },
        
        async updateCartCount() {
            try {
                const response = await fetch('/cart.js');
                const cart = await response.json();
                
                // Update cart count in header if you have one
                const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count]');
                cartCountElements.forEach(element => {
                    element.textContent = cart.item_count;
                });
                
                // Trigger custom event for other components to listen to
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
                
            } catch (error) {
                console.error('Error updating cart count:', error);
            }
        }
    }));
    
    // Variant dropdown component
    Alpine.data('variantDropdown', () => ({
        showDropdown: false,
        selectedVariant: null,
        
        toggleDropdown() {
            this.showDropdown = !this.showDropdown;
        },
        
        selectVariant(variant) {
            this.selectedVariant = variant;
            this.showDropdown = false;
        }
    }));
});

// Tooltip function (if you need it for mobile)
function tooltips() {
    // Add your tooltip logic here if needed
    console.log('Tooltip clicked');
}